/** Qué página impresa se está leyendo.
 *
 *  El 77 % de los párrafos de Quadrado cruzan un salto de página: son largos y la caja de 1884 era
 *  pequeña. Por eso no basta con la página en la que *empieza* el párrafo visible —así el facsímil
 *  se quedaba una página atrás durante casi toda la lectura—. Se mira el último anclaje de página
 *  que ha pasado por encima de la línea de lectura: el comienzo de un párrafo o el salto marcado
 *  dentro de él.
 */
export interface AnclaPagina {
  /** posición del anclaje respecto al alto del contenedor */
  top: number;
  page: number;
}

/** La página del último anclaje que queda por encima de la línea; si ninguno, la del primero. */
export function paginaEnLinea(anclas: AnclaPagina[], linea: number): number | undefined {
  let actual: number | undefined;
  for (const a of anclas) {
    if (a.top <= linea) actual = a.page;
    else break;
  }
  return actual ?? anclas[0]?.page;
}
